<template>
    <v-row class="d-flex justify-center mt-0">
        <v-col cols="12">
            <!-- FILTROS -->
            <v-expansion-panels v-model="panel">
                <v-expansion-panel readonly>
                    <v-btn style="position: absolute; top: -15px; right: 55px; z-index: 1" color="success"
                        title="Cargar ticket" small fab @click="abrirModalCargar(true)">
                        <v-icon>fas fa-plus</v-icon>
                    </v-btn>
                    <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
                        <div>
                            <v-icon class="mb-1" left>fas fa-filter</v-icon>
                            Filtro
                        </div>
                        <template v-slot:actions>
                            <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                                <v-icon>fas fa-chevron-down</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-1">
                        <v-form @submit.prevent="buscar()">
                            <v-row>
                                <v-col cols="7" sm="3" xl="2" class="py-1">
                                    Solicitante
                                    <v-autocomplete v-model="filtro.solicitante" item-text="nombreBusqueda"
                                        item-value="Usuario_id" tabindex="1" :items="usuarios_solicitantes" hide-details
                                        clearable outlined dense></v-autocomplete>
                                </v-col>
                                <v-col cols="5" sm="2" class="py-1">
                                    N° Ticket
                                    <v-text-field v-model.trim="filtro.ticket_id" tabindex="1" type="number"
                                        hide-details outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" xl="2" class="py-1">
                                    Tipo
                                    <v-autocomplete v-model="filtro.tipo_ticket" item-text="nombre" item-value="tipo_id"
                                        tabindex="1" :items="tipos_tickets" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Estado
                                    <v-autocomplete v-model="filtro.estado" item-text="nombre" item-value="estado_id"
                                        tabindex="1" :items="estados" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>

                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Usuario asignado
                                    <v-autocomplete v-model="filtro.usuario_asignado" item-text="Username"
                                        item-value="Usuario_id" tabindex="1" :items="usuarios_mesa" hide-details
                                        clearable outlined dense></v-autocomplete>
                                </v-col>

                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Usuario finalización
                                    <v-autocomplete v-model="filtro.usuario_finalizacion" item-text="Username"
                                        item-value="Usuario_id" tabindex="1" :items="usuarios_mesa" hide-details
                                        clearable outlined dense></v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Prioridad
                                    <v-autocomplete v-model="filtro.prioridad_id" item-text="nombre"
                                        item-value="prioridad_id" tabindex="1" :items="prioridades" hide-details
                                        clearable outlined dense>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Empresa
                                    <v-autocomplete v-model="filtro.familia" item-text="nombre" item-value="id"
                                        tabindex="1" :items="familias" hide-details clearable outlined dense
                                        @change="setSucursal"></v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Sucursal
                                    <v-autocomplete v-model="filtro.sucursal" item-text="provincia" item-value="id"
                                        tabindex="1"
                                        :items="sucursales.filter(suc => suc.familia_id === filtro?.familia)"
                                        hide-details clearable outlined dense></v-autocomplete>
                                </v-col>

                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Area
                                    <v-autocomplete v-model="filtro.area_id" item-text="nombre" item-value="area_id"
                                        tabindex="1" :items="areas" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="3" xl="2" class="py-1">
                                    Origen
                                    <v-autocomplete v-model="filtro.origen" item-text="nombre" item-value="origen_id"
                                        tabindex="1" :items="origenes" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="3" md="4" class="py-1">
                                    Asunto
                                    <v-text-field v-model.trim="filtro.asunto" tabindex="1" hide-details outlined
                                        dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" class="pt-8">
                                    <v-switch v-model="filtro.por_fechas" class="mt-n1 ml-4"
                                        :label="filtro.por_fechas ? 'Ocultar fechas' : 'Filtrar por fechas'"
                                        hide-details></v-switch>
                                </v-col>

                                <v-col cols="12" sm="3" md="3" class="pt-8">

                                </v-col>

                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Período creación
                                    <PeriodoPicker v-model="filtro.periodo_creacion" clearable hide-details />
                                </v-col>
                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Período finalización
                                    <PeriodoPicker v-model="filtro.periodo_finalizacion" clearable hide-details />
                                </v-col>
                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Fecha creación desde
                                    <FechaPicker v-model="filtro.fecha_creacion_desde" clearable hide-details />
                                </v-col>
                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Fecha creación hasta
                                    <FechaPicker v-model="filtro.fecha_creacion_hasta" clearable hide-details />
                                </v-col>
                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Fecha finalización desde
                                    <FechaPicker v-model="filtro.fecha_finalizacion_desde" clearable hide-details />
                                </v-col>
                                <v-col v-if="filtro.por_fechas" cols="6" sm="3" md="3" class="py-1">
                                    Fecha finalización hasta
                                    <FechaPicker v-model="filtro.fecha_finalizacion_hasta" clearable hide-details />
                                </v-col>
                                <BtnFiltro :loading="load" @clear="limpiarFiltros()" />
                            </v-row>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <!-- TICKETS -->
            <v-data-table v-model="selected" :single-select="true" class="cebra elevation-2 mt-2" sort-by="ticket_id"
                :items="tickets" @click:row="rowClick" :headers="headers" :loading="load" :search="search" sort-desc
                dense :item-key="'ticket_id'" @contextmenu:row="click_derecho">
                <!-- busqueda local -->
                <template v-slot:top>
                    <v-row class="d-flex justify-end pa-2" no-gutters>
                        <v-col cols="6" sm="3" xl="2">
                            <SearchDataTable v-model="search" />
                        </v-col>
                    </v-row>
                </template>
                <!--template para formatos personalizados -->
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    {{ header.formatter(value) }}
                </template>
                <!-- estado colores -->
                <template v-slot:[`item.estado_nombre`]="{ item }">
                    <v-chip
                        :color="estados.find(e => e.estado_id == item.estado_id) ? estados.find(e => e.estado_id == item.estado_id).color : ''"
                        small>
                        {{ item.estado_nombre }}
                    </v-chip>
                </template>


                <template v-slot:[`item.prioridad_nombre`]="{ item }">
                    <v-chip v-if="item.prioridad_nombre" :color="item.prioridad_color" small>
                        {{ item.prioridad_nombre }}
                    </v-chip>
                </template>

                <template v-slot:[`item.solicitante_usuario`]="{ item }">
                    <div style="display: flex; flex-wrap: nowrap;">
                        <span>{{ item.solicitante_usuario }}</span>
                        <v-tooltip x-small bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon class="ml-1 mb-1" x-small color="" dark v-bind="attrs" v-on="on">
                                    fas fa-info-circle
                                </v-icon>
                            </template>
                            <span>{{ item.solicitante_nombre }}</span>
                        </v-tooltip>
                    </div>
                </template>
                <!-- no data -->
                <template v-slot:no-data>
                    <v-alert class="mx-auto mt-4" max-width="400" type="warning" border="left" dense text>
                        No hay datos para los filtros seleccionados
                    </v-alert>
                </template>
            </v-data-table>

            <!-- VISUALIZACION DE TICKETS -->
            <v-expand-transition>
                <section id="detalle">
                    <!-- DETALLE -->
                    <v-card v-if="selected.length > 0" class="my-2">
                        <v-card-title class="d-flex justify-end pb-0 pt-1 pr-1">
                            <v-btn title="Cerrar detalle" icon x-small @click="selected = []">
                                <v-icon>fas fa-times</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-title class="py-2" style="word-break: normal">
                            Ticket Nº {{ selected[0].ticket_id }} - {{ selected[0].asunto }} - AREA: {{
                                selected[0].area_nombre }}
                                <br>
                                Teamviewer: {{ selected[0].teamviewer }}
                            <v-spacer></v-spacer>
                            <v-chip
                                :color="estados.find(e => e.estado_id == selected[0].estado_id) ? estados.find(e => e.estado_id == selected[0].estado_id).color : ''">
                                {{ selected[0].estado_nombre }}
                            </v-chip>
                        </v-card-title>
                        <v-col cols="12" class="d-flex mt-n4 pb-0 px-4" style="font-size: 13px;">
                            Cargado por {{ selected[0].solicitante_nombre }} el {{
                                moment.utc(selected[0].fecha_creacion).format('DD/MM/YY [a las] HH:mm') }}
                        </v-col>
                        <v-card-text class="pt-1">
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="selected[0].descripcion" rows="3" hide-details auto-grow
                                        outlined readonly filled dense></v-textarea>
                                </v-col>
                                <v-col cols="12" class="pt-0">
                                    <v-chip
                                        v-for="(archivo, index) in archivos.filter(a => (a.ticket_id === selected[0].archivos.find(ar => ar.ticket_id === a.ticket_id)?.ticket_id) && a.comentario_id == null)"
                                        class="mb-1 mr-2" :color="get_atributo_x_extension(archivo.extension, 'color')"
                                        :key="index" dark @click="ver_archivo(archivo)">
                                        <v-icon class="ml-1" left>{{ get_atributo_x_extension(archivo.extension,
                                            'icono')
                                        }}</v-icon>
                                        {{ archivo.nombre }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- COMENTARIOS -->
                    <v-card v-if="selected.length > 0 && !(comentarios.length == 0 && selected[0].respuesta)">
                        <v-card-title class="py-2" style="word-break: normal">
                            Comentarios
                        </v-card-title>
                        <v-card-text>
                            <v-row v-if="load_comentario">
                                <v-skeleton-loader style="width: 100%;"
                                    type="list-item-avatar-three-line"></v-skeleton-loader>
                                <v-skeleton-loader style="width: 100%;" type="actions"></v-skeleton-loader>
                            </v-row>
                            <v-row v-else>
                                <!-- "chat" -->
                                <v-col v-for="(comentario, index) in comentarios" :key="index" cols="12" class="d-flex">
                                    <!-- icono usuario -->
                                    <v-avatar v-if="comentario.es_comentario_mesa != 1 && !$vuetify.breakpoint.xs"
                                        color="cyan" class="mr-3" style="font-size:22px; cursor: default">
                                        <v-icon>fas fa-user</v-icon>
                                    </v-avatar>
                                    <v-card style="width: 100%;">
                                        <v-card-text class="d-flex pb-1 pt-2 px-3">
                                            <span class="font-weight-bold body-1">
                                                {{ comentario.usuario_nombre }} <span
                                                    v-if="comentario.es_comentario_interno"> -
                                                    COMENTARIO INTERNO</span>
                                            </span>
                                            <v-spacer></v-spacer>
                                            <span class="text-right">
                                                {{ moment.utc(comentario.fecha).format('DD/MM/YYYY HH:mm') }}
                                            </span>
                                        </v-card-text>
                                        <!-- comentario -->
                                        <v-card-text class="d-flex py-0 pb-1 px-3 body-1">
                                            {{ comentario.descripcion }}
                                        </v-card-text>
                                        <!-- archivos -->
                                        <v-card-text class="py-1 px-3">
                                            <v-chip
                                                v-for="(archivo, index) in archivos.filter(a => a.comentario_id == comentario.comentario_id)"
                                                class="mb-1 mr-2"
                                                :color="get_atributo_x_extension(archivo.extension, 'color')"
                                                :key="index" small dark @click="ver_archivo(archivo)">
                                                <v-icon class="ml-1" small left>{{
                                                    get_atributo_x_extension(archivo.extension,
                                                        'icono') }}</v-icon>
                                                {{ archivo.nombre }}
                                            </v-chip>
                                        </v-card-text>
                                    </v-card>
                                    <!-- icono admin -->
                                    <v-avatar v-if="comentario.es_comentario_mesa == 1 && !$vuetify.breakpoint.xs"
                                        :color="$vuetify.theme.dark ? 'lime darken-1' : 'lime'" class="ml-3"
                                        style="font-size:22px; cursor: default">
                                        <v-icon>fas fa-desktop</v-icon>
                                    </v-avatar>
                                </v-col>
                                <!-- enviar comentario -->
                                <template v-if="!selected[0].respuesta">
                                    <v-col cols="12" sm="10">
                                        <v-switch v-model="es_comentario_interno" label="Comentario interno"
                                            hide-details class="mt-0 pt-0 mb-2"></v-switch>
                                        <v-textarea v-model.trim="comentario" rows="2" hide-details outlined
                                            dense></v-textarea>
                                        <div v-if="archivos_adjuntos.length > 0" class="mt-1">
                                            <strong>
                                                {{ archivos_adjuntos.length }} archivo{{ archivos_adjuntos.length == 1 ?
                                                    '' : 's' }} adjunto{{ archivos_adjuntos.length == 1 ? '' : 's' }}:
                                            </strong>
                                            {{archivos_adjuntos.map(a => a.name).join(', ')}}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="2" class="d-flex justify-end align-center">
                                        <v-btn color="info" class="mr-3" title="Adjuntar archivos" small fab
                                            @click="dialog_archivos = true">
                                            <v-icon>fas fa-paperclip</v-icon>
                                        </v-btn>
                                        <v-btn color="success" class="mr-0 mr-md-3" title="Enviar comentario" small fab
                                            @click="enviar_comentario()">
                                            <v-icon class="mr-1">fas fa-paper-plane</v-icon>
                                        </v-btn>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- RESPUESTA -->
                    <v-card v-if="selected.length > 0 && selected[0].respuesta" class="mt-2">
                        <v-card-title class="pt-2 pb-0" style="word-break: normal">
                            Respuesta
                        </v-card-title>
                        <div class="body-1 mx-4">
                            Finalizado por {{ selected[0].usuario_finalizacion_nombre }} el {{
                                moment.utc(selected[0].fecha_finalizacion).format('DD/MM/YY [a las] HH:mm') }}
                        </div>
                        <v-card-text class="pt-2">
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="selected[0].respuesta.descripcion" rows="3" hide-details
                                        auto-grow outlined readonly filled dense></v-textarea>
                                </v-col>
                                <v-col cols="12" class="pt-0">
                                    <v-chip
                                        v-for="(archivo, index) in archivos.filter(a => (a.comentario_id === selected[0].archivos.find(ar => ar.comentario_id === a.comentario_id)?.comentario_id) && a.estado_ticket_id === 3)"
                                        class="mb-1 mr-2" :color="get_atributo_x_extension(archivo.extension, 'color')"
                                        :key="index" dark @click="ver_archivo(archivo)">
                                        <v-icon class="ml-1" left>{{ get_atributo_x_extension(archivo.extension,
                                            'icono')
                                        }}</v-icon>
                                        {{ archivo.nombre }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="d-flex pt-0 pb-3 justify-end mx-2">
                            <v-btn color="warning" @click="abrirModalCargar(false)">
                                <v-icon left>fas fa-reply</v-icon>
                                Reabrir ticket
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </section>
            </v-expand-transition>
        </v-col>
        <v-menu v-model="mostrarMenu" :position-x="x" :position-y="y" absolute offset-y>
            <v-list>
                <v-list-item @click="abrirModalAsignar()"
                    v-if="ticketSeleccionado && (ticketSeleccionado.estado_id === 1 || ticketSeleccionado.estado_id === 2)">
                    <v-list-item-title style="display: flex; align-items: center;">
                        <v-icon color="info" small left>fas fa-user-plus</v-icon>
                        <span>{{ ticketSeleccionado.estado_id === 1 ? 'Asignar' : 'Reasignar' }}</span>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="autoasignar()" v-if="ticketSeleccionado && ticketSeleccionado.estado_id === 1">
                    <v-list-item-title style="display: flex; align-items: center;">
                        <v-icon color="deep-purple darken-1" small left>fas fa-user-tag</v-icon>
                        <span>Autoasignar</span>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirModalEditar()" v-if="ticketSeleccionado && ticketSeleccionado.estado_id != 3">
                    <v-list-item-title style="display: flex; align-items: center;">
                        <v-icon color="warning" small left>fas fa-pen</v-icon>
                        <span>Editar</span>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirModalFinalizar()"
                    v-if="ticketSeleccionado && (ticketSeleccionado.estado_id === 1 || ticketSeleccionado.estado_id === 2)">
                    <v-list-item-title style="display: flex; align-items: center;">
                        <v-icon color="success" small left>fas fa-check-circle</v-icon>
                        <span>Finalizar</span>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirModalCargar(false)"
                    v-if="ticketSeleccionado && ticketSeleccionado.estado_id === 3">
                    <v-list-item-title style="display: flex; align-items: center;">
                        <v-icon color="success" small left>fas fa-reply</v-icon>
                        <span>Reabrir</span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <AsignarTicket v-model="modalAsignar" :prioridades="prioridades" :usuarios="usuarios_mesa"
            :ticket="ticketSeleccionado" @actualizarComentarios="actualizar_comentario($event)" :areas="areas"
            :tipos_tickets="tipos_tickets" :origenes="origenes" @actualizarTicket="actualizar_ticket($event)"
            @actualizar="buscar()" />
        <!-- <NuevoTicket v-model="dialog" :titulo="titulo" @actualizar="buscar()" :reabierto="selected[0]" /> -->
        <EditarTicket v-model="modalEditar" :empresas="familias" :tipos_tickets="tipos_tickets" :origenes="origenes"
            :ticket="ticketSeleccionado" :areas="areas" :prioridades="prioridades"
            @actualizarTicket="actualizar_ticket($event)" />
        <FinalizarTicket v-model="modalFinalizar" :ticket="ticketSeleccionado"
            @actualizarTicket="actualizar_ticket($event)" />
        <ImgViewer v-model="dialog_img" :img="img" :nombre="nombre_ver" />
        <PDFViewer v-model="dialog_pdf" :pdf="pdf" :nombre="nombre_ver" :titulo="nombre_ver" />
        <AdjuntarArchivos v-model="dialog_archivos" :archivos.sync="archivos_adjuntos" />
        <CargarTicketMesa v-model="dialog" @actualizar="buscar()" :ticket="cargaTicket"
            :solicitantes="usuarios_solicitantes" :origenes="origenes" :tipos_tickets="tipos_tickets" :areas="areas"
            :usuarios_mesa="usuarios_mesa" :prioridades="prioridades" @actualizarTicket="actualizar_ticket($event)" />
        <Autoasignar v-model="modalAutoasignar" :empresas="familias" :tipos_tickets="tipos_tickets" :origenes="origenes"
            :ticket="ticketSeleccionado" :areas="areas" :prioridades="prioridades"
            @actualizarTicket="actualizar_ticket($event)" />
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import BtnFiltro from '../../components/util/BtnFiltro.vue';
import { format_date, tipos_archivos, getBase64 } from '../../util/utils'
import SearchDataTable from '../../components/util/SearchDataTable'
import moment from 'moment';
import AsignarTicket from '../../components/tickets/AsignarTicket.vue';
import NuevoTicket from '../../components/tickets/NuevoTicket.vue';
import ImgViewer from '../../components/util/ImgViewer'
import PDFViewer from '../../util/plantillas/PDFViewer'
import AdjuntarArchivos from '../../components/incidentes/AdjuntarArchivos'
import { convertImageToWebp } from '../../util/imagenes';
import EditarTicket from '../../components/tickets/EditarTicket.vue';
import FinalizarTicket from '../../components/tickets/FinalizarTicket.vue';
import CargarTicketMesa from '../../components/tickets/CargarTicketMesa.vue';
import Autoasignar from '../../components/tickets/Autoasignar.vue';
import PeriodoPicker from '../../components/util/PeriodoPicker.vue'
import FechaPicker from '../../components/util/FechaPicker.vue'
export default {
    data() {
        return {
            load: false,
            panel: 0,
            search: '',
            selected: [],

            mostrarMenu: false,
            x: 0,
            y: 0,

            titulo: '',

            es_ticket_finalizado: false,

            archivos_adjuntos: [],

            pdf: null,
            img: null,

            dialog: false,
            dialog_pdf: false,
            dialog_img: false,
            dialog_archivos: false,
            modalAsignar: false,
            modalEditar: false,
            modalFinalizar: false,
            modalAutoasignar: false,

            nombre_ver: '',

            comentario: '',
            es_comentario_interno: false,

            cargaTicket: {},

            titulo: '',
            load_comentario: false,
            moment: moment,
            tickets: [],
            tipos_tickets: [],
            origenes: [],
            estados: [],
            usuarios_solicitantes: [],
            usuarios_mesa: [],

            ticketSeleccionado: {},

            comentarios: [],
            archivos: [],
            areas: [],
            prioridades: [],

            filtro: {
                solicitante: null,
                ticket_id: null,
                tipo_ticket: null,
                estado: null,
                familia: null,
                sucursal: null,
                area_id: null,
                origen: null,
                asunto: '',

                por_fechas: false,

                periodo_creacion: '',
                periodo_finalizacion: '',
                fecha_creacion_desde: '',
                fecha_creacion_hasta: '',
                fecha_finalizacion_desde: '',
                fecha_finalizacion_hasta: '',
                prioridad_id: null,
                usuario_asignado: null,
                usuario_finalizacion: null
            },

            headers: [
                { text: 'Id', value: 'ticket_id', align: 'center' },
                { text: 'Solicitante', value: 'solicitante_usuario' },
                { text: 'Asunto', value: 'asunto', sortable: false },
                { text: 'Estado', value: 'estado_nombre' },
                { text: 'Prioridad', value: 'prioridad_nombre' },

                { text: 'Tipo', value: 'tipo_nombre' },
                { text: 'Origen', value: 'origen_nombre' },
                { text: 'Empresa', value: 'familia_nombre' },

                { text: 'Fecha creación', value: 'fecha_creacion', formatter: format_date },
                { text: 'Usuario asignado', value: 'usuario_asignado_nombre', sortable: false },
                { text: 'Fecha finalización', value: 'fecha_finalizacion', formatter: format_date },
                { text: 'Usuario finalización', value: 'usuario_finalizacion', sortable: false }
            ],
        };
    },

    async created() {
        this.$store.state.loading = true
        // this.filtro.periodo_creacion = moment().startOf('month').format('MM/YYYY');
        await this.$store.dispatch('genericos/get_sucursales')
        await this.$store.dispatch('tickets/getTiposTickets').then(res => {
            if (res.exito) {
                this.tipos_tickets = res.data

                this.tipos_tickets = this.tipos_tickets.sort((a, b) =>
                    a.nombre.localeCompare(b.nombre)
                )
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        await this.$store.dispatch('tickets/getEstadosTickets').then(res => {
            if (res.exito) {
                this.estados = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        await this.$store.dispatch('tickets/getOrigenes').then(res => {
            if (res.exito) {
                this.origenes = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })

        await this.$store.dispatch('tickets/getSolicitantes').then(res => {
            if (res.exito) {
                this.usuarios_solicitantes = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }

        })

        await this.$store.dispatch('tickets/getFamiliasSolicitantes').then(res => {
            if (res.exito) {
                const familiasPorUsuarios = res.data
                this.usuarios_solicitantes = this.usuarios_solicitantes.map(usuario => {
                    let familiasDelUsuario = familiasPorUsuarios.filter(fam => fam.Usuario_id === usuario.Usuario_id)
                    familiasDelUsuario = familiasDelUsuario.map(fam => fam.Familia_id)

                    let nombreBusqueda = `${usuario.Nombre} ${usuario.Apellido} - ${usuario.Username}`

                    return {
                        ...usuario,
                        familias: familiasDelUsuario,
                        nombreBusqueda
                    }
                })

                this.usuarios_solicitantes = this.usuarios_solicitantes.sort((a, b) =>
                    a.nombreBusqueda.localeCompare(b.nombreBusqueda)
                )
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })


        await this.$store.dispatch('tickets/getAreas').then(res => {
            if (res.exito) {
                this.areas = res.data
                this.areas = this.areas.sort((a, b) =>
                    a.nombre.localeCompare(b.nombre)
                )
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }

        })

        await this.$store.dispatch('tickets/getPrioridades').then(res => {
            if (res.exito) {
                this.prioridades = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })

        await this.$store.dispatch('tickets/getInfoMesa').then(res => {
            if (res.exito) {
                this.usuarios_mesa = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })


        await this.buscar()
        this.$store.state.loading = false
    },
    computed: {
        ...mapState(['familias']),
        ...mapState('genericos', ['sucursales'])
    },
    methods: {

        async buscar() {
            this.tickets = []
            this.load = true
            await this.$store.dispatch('tickets/getTicketsMesa', this.filtro).then(res => {
                if (res.exito) {
                    this.tickets = res.data
                } else {
                    this.$store.dispatch('show_snackbar', {
                        text: res.message,
                        color: 'error'
                    })
                }
            })
            this.load = false
        },

        abrirModalAsignar(item) {
            this.modalAsignar = true
        },

        abrirModalEditar(item) {
            this.modalEditar = true
        },

        abrirModalFinalizar() {
            this.modalFinalizar = true
        },

        abrirModalCargar(esCarga) {
            if (esCarga) {
                this.cargaTicket = {}
            } else {
                this.cargaTicket = this.ticketSeleccionado
            }
            this.dialog = true;
        },

        async autoasignar() {
            this.load = true


            // SI TIENE TIPOS Y AREAS

            if (this.ticketSeleccionado?.tipo_ticket_id && this.ticketSeleccionado?.area_id && this.ticketSeleccionado?.origen_id) {
                await this.$store.dispatch('tickets/autoasignarTicket', {
                    ticket_id: this.ticketSeleccionado?.ticket_id
                }).then(res => {
                    if (res.exito) {
                        // Encontrar el índice del ticket
                        const index = this.tickets.findIndex(
                            t => t.ticket_id === res.data.ticket_id
                        );

                        if (index !== -1) {
                            // Actualizar reactivamente usando $set
                            this.tickets.splice(index, 1, res.data);
                            this.$store.dispatch('show_snackbar', {
                                text: res.message,
                                color: 'success'
                            })
                        }

                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        });
                    }
                }).catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    });
                    return
                })
            } else {
                this.modalAutoasignar = true
            }
            this.load = false
        },






        async enviar_comentario() {
            if (!this.comentario.trim()) {
                return this.$store.dispatch('show_snackbar', {
                    text: 'No puede enviar un comentario vacio',
                    color: 'orange'
                })
            }
            // valido si en algun lado del comentario puso adjunto para avisarle por si no adjuntó nada
            const tiene_adjunto = this.comentario.toLowerCase().indexOf('adjunto') >= 0
            const tiene_archivo = this.comentario.toLowerCase().indexOf('archivo') >= 0
            if ((tiene_adjunto || tiene_archivo) && this.archivos_adjuntos.length == 0) {
                let ups_me_olvide_el_archivo = false
                let abrir_modal = false
                await this.$swal.fire({
                    icon: 'warning',
                    html: `Se encontró la palabra <strong>${tiene_archivo ? 'archivo' : ''} ${tiene_adjunto ? 'adjunto' : ''}</strong> en el comentario pero no se
            seleccionó ningún archivo.<div style="font-size: 20px; margin-top: 12px"><strong>¿Desea enviar el comentario de todas formas?</strong></div>`,
                    confirmButtonText: 'Sí, enviar de todas formas',
                    denyButtonText: 'No, seleccionar archivos',
                    denyButtonColor: '#3085d6',
                    showDenyButton: true,
                    focusDeny: true
                })
                    .then((res) => {
                        abrir_modal = res.isDenied
                        // si pone que no o hace click fuera del modal no hace nada
                        if (!res.isConfirmed) {
                            ups_me_olvide_el_archivo = true
                        }
                    })
                if (abrir_modal) this.dialog_archivos = true
                if (ups_me_olvide_el_archivo) return
            }
            this.$store.state.loading = true
            let archivos = []
            let nombreArchivos = []
            // convierto los archivos en base64


            if (this.archivos_adjuntos.length > 0) {
                for (const archivo of this.archivos_adjuntos) {
                    // Convertir a WebP si es imagen, o dejar el archivo original si no lo es
                    const archivoConvertido = await convertImageToWebp(archivo);
                    // Agregar el nombre del archivo convertido (con extensión .webp si aplicó)
                    nombreArchivos.push(archivoConvertido.name);
                    // Convertir a base64
                    const fileBase64 = await getBase64(archivoConvertido);
                    archivos.push(fileBase64);
                }
            }

            if (!this.selected[0]?.usuario_asignado) {
                await this.$store.dispatch('tickets/autoasignarTicket', {
                    ticket_id: this.selected[0]?.ticket_id
                }).then(async res => {
                    if (res.exito) {
                        // Encontrar el índice del ticket
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'success'
                        });
                        this.actualizar_ticket(res.data)
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        });
                    }
                }).catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    });
                    return
                })
            }

            let es_comentario_mesa = 1
            await this.$store.dispatch('tickets/nuevoComentario', {
                id: this.selected[0].ticket_id,
                comentario: this.comentario,
                es_comentario_mesa,
                usuario_nombre: `${this.$store.state.usuario.nombre} ${this.$store.state.usuario.apellido}`,
                estado_ticket_id: this.selected[0].estado_id,
                es_comentario_interno: this.es_comentario_interno ? 1 : 0
            })
                .then(async (res) => {
                    if (res.exito) {
                        this.comentario = ''
                        this.comentarios.push(res.data)
                        if (archivos.length === 0) {
                            await this.$swal.fire({
                                icon: res.exito ? 'success' : 'warning',
                                title: res.message,
                            })
                        } else {
                            await this.$store
                                .dispatch('tickets/cargarArchivos', {
                                    archivos,
                                    nombreArchivos,
                                    ticket_id: this.selected[0].ticket_id,
                                    estado_id: this.selected[0].estado_id,
                                    comentario_id: res.data.comentario_id
                                })
                                .then(resArchivos => {
                                    if (resArchivos.exito) {
                                        this.archivos_adjuntos = []
                                        resArchivos.data.forEach(archivo => {
                                            this.archivos.push(archivo)
                                        })
                                        if (resArchivos.feedbackFallidos.length > 0) {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                                html: `<strong>${resArchivos.feedbackFallidos}</strong>`,
                                                width: '450px'
                                            })
                                        } else {
                                            this.$swal.fire({
                                                icon: 'success',
                                                title: resArchivos.message,
                                            })
                                        }
                                    } else {
                                        this.$store.dispatch('show_snackbar', {
                                            text: resArchivos.message,
                                            color: 'error'
                                        })
                                    }
                                })
                        }
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        })
                    }
                })
                .catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    })
                })
            this.$store.state.loading = false
        },

        actualizar_comentario(event) {
            this.comentarios.push(event)
        },

        get_atributo_x_extension(extension, atributo) {
            return tipos_archivos.find(a => a.extension == extension) ? tipos_archivos.find(a => a.extension == extension)[atributo] : ''
        },

        actualizar_ticket(ticket) {
            const index = this.tickets.findIndex(
                t => t.ticket_id === ticket?.ticket_id
            );

            if (index !== -1) {
                this.tickets.splice(index, 1, ticket);
            }
        },

        setSucursal() {
            const sucursal = this.sucursales.filter(
                suc => suc.familia_id === this.filtro.empresa
            )
            sucursal.length === 1 ? (this.filtro.sucursal = sucursal[0].id) : null
        },

        rowClick(item) {
            // Deseleccionar si ya está seleccionado
            if (this.selected.length > 0 && this.selected[0].ticket_id === item.ticket_id) {
                this.selected = [];
            } else {
                this.selected = [item];
                this.ticketSeleccionado = this.selected[0] || {}
            }
            this.$nextTick(() => {
                if (this.selected.length > 0) {
                    this.$vuetify.goTo('#detalle');
                }
            });
        },

        limpiarFiltros() {
            this.filtro = {
                solicitante: null,
                ticket_id: null,
                tipo_ticket: null,
                estado: null,
                familia: null,
                sucursal: null,
                area_id: null,
                origen: null,
                asunto: '',
                periodo_creacion: '',
                periodo_finalizacion: '',
                fecha_creacion_desde: '',
                fecha_creacion_hasta: '',
                fecha_finalizacion_desde: '',
                fecha_finalizacion_hasta: '',
                prioridad_id: null,
                usuario_asignado: null,
                usuario_finalizacion: null,
                por_fechas: this.filtro.por_fechas
            }
        },

        get_atributo_x_extension(extension, atributo) {
            return tipos_archivos.find(a => a.extension == extension) ? tipos_archivos.find(a => a.extension == extension)[atributo] : ''
        },

        ver_archivo(archivo, ruta) {
            const tipo = this.get_atributo_x_extension(archivo.extension, 'tipo')
            this.nombre_ver = archivo.nombre
            if (tipo == 'IMG') {
                this.img = archivo.url
                this.dialog_img = true
            }
            else if (tipo == 'PDF') {
                this.pdf = archivo.url
                this.dialog_pdf = true
            }
            else {
                window.open(archivo.url, '_blank')
            }
        },

        click_derecho(event, item) {
            event.preventDefault()
            this.mostrarMenu = false
            this.x = event.clientX
            this.y = event.clientY

            if (item) {
                this.$nextTick(() => {
                    this.ticketSeleccionado = JSON.parse(JSON.stringify(item.item))
                    this.es_ticket_finalizado = this.ticketSeleccionado.estado_id === 3
                    this.mostrarMenu = true
                })
            } else {
                this.$nextTick(() => {
                    this.mostrarMenu = false
                })
            }
        },
    },

    watch: {
        async selected(newVal, oldVal) {
            this.archivos = []
            this.comentarios = []
            this.archivos_adjuntos = []
            this.comentario = ''

            if (this.selected[0]) {
                if (this.selected[0].archivos) {
                    this.archivos = this.selected[0].archivos
                }
                if (this.selected[0].comentarios) {
                    this.comentarios = this.selected[0].comentarios
                }
            }
            // obtiene las imagenes del registro seleccionado solo cuando lo selecciona por primera vez
            if (newVal.length == 1 && ((oldVal.length == 0) || (oldVal[0].ticket_id != newVal[0].ticket_id))) {
                const id = await JSON.parse(JSON.stringify(this.selected[0].ticket_id))
                let selected = this.tickets.find(c => c.ticket_id == id)
                if (!selected.archivos) {
                    this.$store.state.loading = true
                    this.load_comentario = true
                    await this.$store.dispatch('tickets/getArchivos', { id: selected.ticket_id })
                        .then((res) => {
                            if (res.exito) {
                                selected.archivos = res.data
                                this.load_comentario = false
                                this.archivos = selected.archivos
                            }
                        })
                        .catch(error => {
                            this.$store.dispatch('show_snackbar', {
                                text: error.message,
                                color: 'error'
                            })
                        })
                    this.$store.state.loading = false
                    this.load_comentario = false
                }
                if (!selected.comentarios) {
                    this.load_comentario = true
                    await this.$store.dispatch('tickets/getComentarios', { id: selected.ticket_id })
                        .then((res) => {
                            if (res.exito) {
                                this.load_comentario = false
                                selected.comentarios = res.data.filter(data => data.estado_ticket_id != 3)
                                this.comentarios = selected.comentarios

                                const comentarioFinalizacion = res.data.length > 0 ? res.data.find(coment => coment.estado_ticket_id === 3) : ''

                                if (comentarioFinalizacion) {
                                    selected.respuesta = comentarioFinalizacion
                                }

                            } else {
                                this.$store.dispatch('show_snackbar', {
                                    text: res.message,
                                    color: 'error'
                                })
                            }
                        })
                        .catch(error => {
                            this.$store.dispatch('show_snackbar', {
                                text: error.message,
                                color: 'error'
                            })
                        })
                    this.load_comentario = false
                }
            }
        }
    },
    components: {
        BtnFiltro,
        SearchDataTable,
        AsignarTicket,
        NuevoTicket,
        ImgViewer,
        PDFViewer,
        AdjuntarArchivos,
        EditarTicket,
        FinalizarTicket,
        CargarTicketMesa,
        Autoasignar,
        PeriodoPicker,
        FechaPicker
    },
};
</script>
